<template>
    <Layout>
        <CompaniesList class="container"/>
    </Layout>
</template>

<script>
    import Layout from "@/components/layouts/Layout.vue";
    import CompaniesList from "../components/subpages/CompaniesList.vue";

    export default {
        components: { Layout, CompaniesList },
    }
</script>